import MenuItem from "api/types/MenuItem";

/**
 * Calculates unit price of menu item with selected options
 */
const calculateMenuItemUnitPriceCents = ({
	menuItem,
	selectedOptions
}: {
	menuItem?: MenuItem;
	selectedOptions?: {
		menuItemOptionId: string;
		menuItemOptionGroupId?: string;
	}[];
}): number => {
	let unitPrice = menuItem?.priceCents || 0;

	if (menuItem?.menuItemOptionGroups?.length) {
		for (const group of menuItem.menuItemOptionGroups) {
			for (const option of group.menuItemOptions) {
				if (option.priceCents) {
					if (selectedOptions?.find(x => x.menuItemOptionGroupId === group.id && x.menuItemOptionId === option.id)) {
						if (option.priceCents) {
							unitPrice += option.priceCents;
						}
					}
				}
			}
		}
	}

	return unitPrice;
};

export default calculateMenuItemUnitPriceCents;
